//配置全局访问接口地址
let commonUrl = "https://movieback.hk9999z.com";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl